import * as React from "react";

const Pictures = (): JSX.Element => <article />;

export default Pictures;
